import { BaseService } from './BaseService';

export class DriverService extends BaseService {
  async getUsers(status, role){
    const response = {
      ok: false,
      message: '',
      users: []
    };
    try {
      return this.http('app/drivers', 'get', {status, role});
    } catch (error) {
      console.log('ERR ',error);
      response.message = error.message;
    }
    return response;
  }
  
  async getDriver(id){
    try {
      return this.http(`app/drivers/${id}`, 'get', {});
    } catch (error) {
      console.log('ERR ',error);
      return {
        ok: false,
        message: error.message
      };
    }
  }

  async getDriverOrders(driverId){
    try {
      return this.http(`app/drivers/${driverId}/orders`, 'get', {});
    } catch (error) {
      console.log('ERR ',error);
      return {
        ok: false,
        message: error.message
      };
    }
  }

  async createDriver(data){
    try {
      return this.http(`app/drivers`, 'post', data);
    } catch (error) {
      console.log('ERR ',error);
      return {
        ok: false,
        message: error.message
      };
    }
  }
}